import React, { useState } from 'react';
import { Check } from 'lucide-react';
export const AIFormTest = () => {
  const [formStep, setFormStep] = useState(1);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formData, setFormData] = useState({
    // Page 1
    fullName: '',
    email: '',
    phone: '',
    profession: '',
    cityState: '',
    hasCreatedWebsite: '',
    aiComfortLevel: '',
    device: [] as string[],
    learningGoal: [] as string[],
    biggestFrustration: [] as string[],
    oneThingToWalkAway: '',
    // Page 2
    interestInMasterclass: '',
    priceWillingness: '',
    investmentFactor: [] as string[],
    monetizationIntent: '',
    audienceToServe: [] as string[],
    monthlyIncomeGoal: '',
    preferredClassStyle: '',
    preferredClassTime: [] as string[],
    practicePreference: [] as string[],
    paymentPlanHelp: '',
    permissionForUpdates: ''
  });
  const handleFormChange = (e: any) => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    if (type === 'checkbox') {
      setFormData(prev => {
        const currentArray = prev[name as keyof typeof prev] as string[];
        if (checked) {
          return {
            ...prev,
            [name]: [...currentArray, value]
          };
        } else {
          return {
            ...prev,
            [name]: currentArray.filter(item => item !== value)
          };
        }
      });
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };
  const handleNextStep = () => {
    setFormStep(2);
    window.scrollTo(0, 0);
  };
  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitStatus('submitting');
    const data = {
      fullName: formData.fullName,
      email: formData.email,
      phone: formData.phone,
      profession: formData.profession,
      city: formData.cityState,
      websiteExperience: formData.hasCreatedWebsite,
      aiComfort: formData.aiComfortLevel,
      device: Array.isArray(formData.device) ? formData.device.join(', ') : formData.device,
      goal: Array.isArray(formData.learningGoal) ? formData.learningGoal.join(', ') : formData.learningGoal,
      frustration: Array.isArray(formData.biggestFrustration) ? formData.biggestFrustration.join(', ') : formData.biggestFrustration,
      oneThing: formData.oneThingToWalkAway,
      masterclassInterest: formData.interestInMasterclass,
      priceRange: formData.priceWillingness,
      investTrigger: Array.isArray(formData.investmentFactor) ? formData.investmentFactor.join(', ') : formData.investmentFactor,
      monetize: formData.monetizationIntent,
      audience: Array.isArray(formData.audienceToServe) ? formData.audienceToServe.join(', ') : formData.audienceToServe,
      monthlyGoal: formData.monthlyIncomeGoal,
      classStyle: formData.preferredClassStyle,
      classTime: Array.isArray(formData.preferredClassTime) ? formData.preferredClassTime.join(', ') : formData.preferredClassTime,
      practicePreference: Array.isArray(formData.practicePreference) ? formData.practicePreference.join(', ') : formData.practicePreference,
      paymentPlan: formData.paymentPlanHelp,
      permission: formData.permissionForUpdates
    };
    console.log('Submitting data:', data);
    try {
      const response = await fetch('https://script.google.com/macros/s/AKfycbx3X11ZnhJ9Qas0Ylp8l7U1OHsjyTtx-u-Zp-mhsA3blmP3aIJBhB4TfhcLmnSFAgtg5A/exec', {
        method: 'POST',
        body: JSON.stringify(data)
      });
      const result = await response.json();
      console.log('Response:', result);
      if (result.result === 'success') {
        setSubmitStatus('success');
        // Redirect to WhatsApp group after successful submission
        setTimeout(() => {
          window.location.href = 'https://chat.whatsapp.com/KuVilCGv5Zn8KqDmdOUoee';
        }, 2000);
      } else {
        setSubmitStatus('error');
        alert('Submission failed. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      setSubmitStatus('error');
      alert('Submission failed. Please try again.');
    }
  };
  if (submitStatus === 'success') {
    return <div className="min-h-screen flex items-center justify-center" style={{
      backgroundColor: '#F9F9F9'
    }} data-id="element-1129">
        <div className="text-center p-8" data-id="element-1130">
          <div className="w-20 h-20 mx-auto mb-6 rounded-full flex items-center justify-center" style={{
          backgroundColor: '#1AB9C8'
        }} data-id="element-1131">
            <Check size={40} style={{
            color: '#FFFFFF'
          }} data-id="element-1132" />
          </div>
          <h1 className="text-3xl font-bold mb-4" style={{
          color: '#0B1F3F'
        }} data-id="element-1133">
            Form Submitted Successfully!
          </h1>
          <p className="text-lg mb-4" style={{
          color: '#333333'
        }} data-id="element-1134">
            Data has been sent to Google Sheets.
          </p>
          <p style={{
          color: '#333333'
        }} data-id="element-1135">
            Redirecting to WhatsApp...
          </p>
        </div>
      </div>;
  }
  return <div className="min-h-screen py-12" style={{
    backgroundColor: '#F9F9F9'
  }} data-id="element-1136">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-1137">
        <div className="mb-8 text-center" data-id="element-1138">
          <h1 className="text-3xl font-bold mb-4" style={{
          color: '#0B1F3F'
        }} data-id="element-1139">
            AI Power Bundle Form Test
          </h1>
          <p className="text-lg" style={{
          color: '#333333'
        }} data-id="element-1140">
            Testing Google Sheets Integration
          </p>
        </div>

        {/* Progress Bar */}
        <div className="mb-8" data-id="element-1141">
          <div className="h-2 rounded-full" style={{
          backgroundColor: '#E5E5E5'
        }} data-id="element-1142">
            <div className="h-full rounded-full transition-all duration-300" style={{
            backgroundColor: '#F4B400',
            width: formStep === 1 ? '50%' : '100%'
          }} data-id="element-1143" />
          </div>
          <p className="text-center mt-2 text-sm" style={{
          color: '#333333'
        }} data-id="element-1144">
            Step {formStep} of 2
          </p>
        </div>

        <form id="aiForm" onSubmit={formStep === 2 ? handleFormSubmit : e => {
        e.preventDefault();
        handleNextStep();
      }} className="space-y-6 p-8 rounded-lg" style={{
        backgroundColor: '#FFFFFF',
        border: '2px solid #E5E5E5'
      }} data-id="element-1145">
          {formStep === 1 ? <>
              <h2 className="text-2xl font-bold mb-6" style={{
            color: '#0B1F3F'
          }} data-id="element-1146">
                Basic Info & Digital Readiness
              </h2>

              <div data-id="element-1147">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1148">
                  Full Name *
                </label>
                <input type="text" name="fullName" value={formData.fullName} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1149" />
              </div>

              <div data-id="element-1150">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1151">
                  Email Address *
                </label>
                <input type="email" name="email" value={formData.email} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1152" />
              </div>

              <div data-id="element-1153">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1154">
                  Phone Number *
                </label>
                <input type="tel" name="phone" value={formData.phone} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1155" />
              </div>

              <div data-id="element-1156">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1157">
                  Current Profession *
                </label>
                <input type="text" name="profession" value={formData.profession} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1158" />
              </div>

              <div data-id="element-1159">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1160">
                  City/State *
                </label>
                <input type="text" name="cityState" value={formData.cityState} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1161" />
              </div>

              <div data-id="element-1162">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1163">
                  Have you ever created a website before? *
                </label>
                <select name="hasCreatedWebsite" value={formData.hasCreatedWebsite} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1164">
                  <option value="" data-id="element-1165">Select...</option>
                  <option value="Yes" data-id="element-1166">Yes</option>
                  <option value="No" data-id="element-1167">No</option>
                </select>
              </div>

              <div data-id="element-1168">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1169">
                  Comfort level with AI tools *
                </label>
                <select name="aiComfortLevel" value={formData.aiComfortLevel} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1170">
                  <option value="" data-id="element-1171">Select...</option>
                  <option value="Beginner" data-id="element-1172">Beginner</option>
                  <option value="Intermediate" data-id="element-1173">Intermediate</option>
                  <option value="Advanced" data-id="element-1174">Advanced</option>
                </select>
              </div>

              <div data-id="element-1175">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1176">
                  Device you work with? * (Select all that apply)
                </label>
                <div className="space-y-2" data-id="element-1177">
                  {['Laptop (Windows)', 'Laptop (Mac)', 'Desktop Computer', 'Tablet', 'Smartphone Only', 'Smartphone + occasional laptop access', 'I currently have no device'].map(option => <label key={option} className="flex items-center" data-id="element-1178">
                      <input type="checkbox" name="device" value={option} checked={formData.device.includes(option)} onChange={handleFormChange} className="mr-2" data-id="element-1179" />
                      <span style={{
                  color: '#333333'
                }} data-id="element-1180">
                        {option}
                      </span>
                    </label>)}
                </div>
              </div>

              <div data-id="element-1181">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1182">
                  What exactly do you want to achieve with this AI Skills Class?
                  * (Choose one or multiple)
                </label>
                <div className="space-y-2" data-id="element-1183">
                  {['Learn how to use AI for everyday productivity', 'Automate repetitive tasks in my work/business', 'Learn how to use AI tools for content creation', 'Build AI-powered workflows (emails, proposals, research, etc.)', 'Create digital products/services using AI', 'Improve my career or become more employable', 'Start a freelance or consulting business using AI', 'Learn how to train or specialize AI for my field', 'Understand AI well enough to teach others', 'Not sure yet — I just want to learn'].map(option => <label key={option} className="flex items-center" data-id="element-1184">
                      <input type="checkbox" name="learningGoal" value={option} checked={formData.learningGoal.includes(option)} onChange={handleFormChange} className="mr-2" data-id="element-1185" />
                      <span style={{
                  color: '#333333'
                }} data-id="element-1186">
                        {option}
                      </span>
                    </label>)}
                </div>
              </div>

              <div data-id="element-1187">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1188">
                  Biggest frustration with learning digital skills? * (Select up
                  to 4)
                </label>
                <div className="space-y-2" data-id="element-1189">
                  {["Too much information — I don't know where to start", 'No one to guide me step-by-step', "I learn but I can't apply it practically", "I don't have enough time", 'Tools feel too complex', 'Training programs are too expensive', 'I learn fast but forget when I try to do it alone', 'My device is slow or limited', 'Poor internet connection', "I'm overwhelmed… everything feels new"].map(option => <label key={option} className="flex items-center" data-id="element-1190">
                      <input type="checkbox" name="biggestFrustration" value={option} checked={formData.biggestFrustration.includes(option)} onChange={handleFormChange} disabled={formData.biggestFrustration.length >= 4 && !formData.biggestFrustration.includes(option)} className="mr-2" data-id="element-1191" />
                      <span style={{
                  color: '#333333'
                }} data-id="element-1192">
                        {option}
                      </span>
                    </label>)}
                </div>
                <p className="text-sm mt-1" style={{
              color: '#666'
            }} data-id="element-1193">
                  Selected: {formData.biggestFrustration.length}/4
                </p>
              </div>

              <div data-id="element-1194">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1195">
                  If you could walk away from this class with ONE thing fully
                  done, what would it be? * (Pick only 1)
                </label>
                <select name="oneThingToWalkAway" value={formData.oneThingToWalkAway} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1196">
                  <option value="" data-id="element-1197">Select one...</option>
                  <option value="My first automated workflow" data-id="element-1198">
                    My first automated workflow
                  </option>
                  <option value="My first AI-created digital product" data-id="element-1199">
                    My first AI-created digital product
                  </option>
                  <option value="My personal AI assistant set up" data-id="element-1200">
                    My personal AI assistant set up
                  </option>
                  <option value="My business processes automated" data-id="element-1201">
                    My business processes automated
                  </option>
                  <option value="My AI portfolio built" data-id="element-1202">
                    My AI portfolio built
                  </option>
                  <option value="My AI content creation system" data-id="element-1203">
                    My AI content creation system
                  </option>
                  <option value="My first AI-powered income stream" data-id="element-1204">
                    My first AI-powered income stream
                  </option>
                  <option value="My resume/LinkedIn profile optimized with AI" data-id="element-1205">
                    My resume/LinkedIn profile optimized with AI
                  </option>
                  <option value="My business marketing system automated" data-id="element-1206">
                    My business marketing system automated
                  </option>
                  <option value="Clarity and confidence using AI tools" data-id="element-1207">
                    Clarity and confidence using AI tools
                  </option>
                  <option value="A full 30-day action plan I can follow" data-id="element-1208">
                    A full 30-day action plan I can follow
                  </option>
                  <option value="Not sure — I want recommendations" data-id="element-1209">
                    Not sure — I want recommendations
                  </option>
                </select>
              </div>

              <button type="submit" className="w-full py-4 rounded-md font-bold text-white text-lg transition-all hover:opacity-90" style={{
            backgroundColor: '#0B1F3F'
          }} data-id="element-1210">
                Next →
              </button>
            </> : <>
              <h2 className="text-2xl font-bold mb-6" style={{
            color: '#0B1F3F'
          }} data-id="element-1211">
                Buying Power & Learning Style
              </h2>

              <div data-id="element-1212">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1213">
                  Interest in full practical masterclass *
                </label>
                <select name="interestInMasterclass" value={formData.interestInMasterclass} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1214">
                  <option value="" data-id="element-1215">Select...</option>
                  <option value="Very Interested" data-id="element-1216">Very Interested</option>
                  <option value="Somewhat Interested" data-id="element-1217">
                    Somewhat Interested
                  </option>
                  <option value="Not Interested" data-id="element-1218">Not Interested</option>
                </select>
              </div>

              <div data-id="element-1219">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1220">
                  Price range you would consider? * (₦100,000–₦250,000)
                </label>
                <select name="priceWillingness" value={formData.priceWillingness} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1221">
                  <option value="" data-id="element-1222">Select...</option>
                  <option value="₦100,000 – ₦130,000" data-id="element-1223">
                    ₦100,000 – ₦130,000
                  </option>
                  <option value="₦130,000 – ₦160,000" data-id="element-1224">
                    ₦130,000 – ₦160,000
                  </option>
                  <option value="₦160,000 – ₦190,000" data-id="element-1225">
                    ₦160,000 – ₦190,000
                  </option>
                  <option value="₦190,000 – ₦220,000" data-id="element-1226">
                    ₦190,000 – ₦220,000
                  </option>
                  <option value="₦220,000 – ₦250,000" data-id="element-1227">
                    ₦220,000 – ₦250,000
                  </option>
                  <option value="I can pay in installments" data-id="element-1228">
                    I can pay in installments
                  </option>
                  <option value="I can only join if there is a scholarship/discount" data-id="element-1229">
                    I can only join if there is a scholarship/discount
                  </option>
                </select>
              </div>

              <div data-id="element-1230">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1231">
                  What would make you confidently invest in a premium hands-on
                  program? * (Choose at most 2)
                </label>
                <div className="space-y-2" data-id="element-1232">
                  {['Step-by-step practical learning', 'Real-life projects I can use immediately', 'A mentor or expert I can ask questions', 'Templates, tools & resources included', 'A clear promise of skill mastery', 'Proof that others got results', 'Certificate + portfolio', 'Live sessions + recordings', 'Community support + accountability', 'Money-back guarantee', 'A clear path to earning with AI', 'Flexible payment options'].map(option => <label key={option} className="flex items-center" data-id="element-1233">
                      <input type="checkbox" name="investmentFactor" value={option} checked={formData.investmentFactor.includes(option)} onChange={handleFormChange} disabled={formData.investmentFactor.length >= 2 && !formData.investmentFactor.includes(option)} className="mr-2" data-id="element-1234" />
                      <span style={{
                  color: '#333333'
                }} data-id="element-1235">
                        {option}
                      </span>
                    </label>)}
                </div>
                <p className="text-sm mt-1" style={{
              color: '#666'
            }} data-id="element-1236">
                  Selected: {formData.investmentFactor.length}/2
                </p>
              </div>

              <div data-id="element-1237">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1238">
                  Do you want to use this skill to earn money? *
                </label>
                <select name="monetizationIntent" value={formData.monetizationIntent} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1239">
                  <option value="" data-id="element-1240">Select...</option>
                  <option value="Yes" data-id="element-1241">Yes</option>
                  <option value="No" data-id="element-1242">No</option>
                  <option value="Maybe" data-id="element-1243">Maybe</option>
                </select>
              </div>

              <div data-id="element-1244">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1245">
                  Audience you plan to serve? * (Choose 2-3)
                </label>
                <div className="space-y-2" data-id="element-1246">
                  {['Small business owners', 'Students / young people', 'Creatives (writers, designers, content creators)', 'NGOs / nonprofits', 'Coaches / consultants', 'Corporate teams', 'Schools / teachers', 'E-commerce businesses', 'Real estate', 'Health & wellness', 'Churches / ministries', 'Anyone who needs digital transformation', 'Not sure yet — I need help choosing'].map(option => <label key={option} className="flex items-center" data-id="element-1247">
                      <input type="checkbox" name="audienceToServe" value={option} checked={formData.audienceToServe.includes(option)} onChange={handleFormChange} disabled={formData.audienceToServe.length >= 3 && !formData.audienceToServe.includes(option)} className="mr-2" data-id="element-1248" />
                      <span style={{
                  color: '#333333'
                }} data-id="element-1249">
                        {option}
                      </span>
                    </label>)}
                </div>
                <p className="text-sm mt-1" style={{
              color: '#666'
            }} data-id="element-1250">
                  Selected: {formData.audienceToServe.length}/3
                </p>
              </div>

              <div data-id="element-1251">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1252">
                  Monthly income goal using AI-assisted skills *
                </label>
                <input type="text" name="monthlyIncomeGoal" value={formData.monthlyIncomeGoal} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1253" />
              </div>

              <div data-id="element-1254">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1255">
                  Preferred class style *
                </label>
                <select name="preferredClassStyle" value={formData.preferredClassStyle} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1256">
                  <option value="" data-id="element-1257">Select...</option>
                  <option value="Live" data-id="element-1258">Live</option>
                  <option value="Recorded" data-id="element-1259">Recorded</option>
                  <option value="Hybrid" data-id="element-1260">Hybrid</option>
                </select>
              </div>

              <div data-id="element-1261">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1262">
                  Preferred Class Time * (Choose 2)
                </label>
                <div className="space-y-2" data-id="element-1263">
                  {['Weekday mornings', 'Weekday afternoons', 'Weekday evenings', 'Saturday mornings', 'Saturday afternoons', 'Saturday evenings', 'Sunday afternoon', 'Fully online & flexible (self-paced + live support)'].map(option => <label key={option} className="flex items-center" data-id="element-1264">
                      <input type="checkbox" name="preferredClassTime" value={option} checked={formData.preferredClassTime.includes(option)} onChange={handleFormChange} disabled={formData.preferredClassTime.length >= 2 && !formData.preferredClassTime.includes(option)} className="mr-2" data-id="element-1265" />
                      <span style={{
                  color: '#333333'
                }} data-id="element-1266">
                        {option}
                      </span>
                    </label>)}
                </div>
                <p className="text-sm mt-1" style={{
              color: '#666'
            }} data-id="element-1267">
                  Selected: {formData.preferredClassTime.length}/2
                </p>
              </div>

              <div data-id="element-1268">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1269">
                  How do you prefer to practice? * (Choose 2)
                </label>
                <div className="space-y-2" data-id="element-1270">
                  {['Guided step-by-step exercises', 'Real project challenges', 'Assignments with feedback', 'Interactive live sessions', 'Solo practice following templates', 'Group practice / paired learning', 'Watching video tutorials', 'Doing it myself with occasional support', 'A combination of everything'].map(option => <label key={option} className="flex items-center" data-id="element-1271">
                      <input type="checkbox" name="practicePreference" value={option} checked={formData.practicePreference.includes(option)} onChange={handleFormChange} disabled={formData.practicePreference.length >= 2 && !formData.practicePreference.includes(option)} className="mr-2" data-id="element-1272" />
                      <span style={{
                  color: '#333333'
                }} data-id="element-1273">
                        {option}
                      </span>
                    </label>)}
                </div>
                <p className="text-sm mt-1" style={{
              color: '#666'
            }} data-id="element-1274">
                  Selected: {formData.practicePreference.length}/2
                </p>
              </div>

              <div data-id="element-1275">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1276">
                  If a payment plan would help you join faster *
                </label>
                <select name="paymentPlanHelp" value={formData.paymentPlanHelp} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1277">
                  <option value="" data-id="element-1278">Select...</option>
                  <option value="Yes" data-id="element-1279">Yes</option>
                  <option value="No" data-id="element-1280">No</option>
                </select>
              </div>

              <div data-id="element-1281">
                <label className="block mb-2 font-medium" style={{
              color: '#333333'
            }} data-id="element-1282">
                  Permission to receive updates on upcoming advanced
                  masterclasses *
                </label>
                <select name="permissionForUpdates" value={formData.permissionForUpdates} onChange={handleFormChange} required className="w-full p-3 rounded-md" style={{
              border: '2px solid #E5E5E5'
            }} data-id="element-1283">
                  <option value="" data-id="element-1284">Select...</option>
                  <option value="Yes" data-id="element-1285">Yes</option>
                  <option value="No" data-id="element-1286">No</option>
                </select>
              </div>

              <div className="flex gap-4" data-id="element-1287">
                <button type="button" onClick={() => setFormStep(1)} className="flex-1 py-4 rounded-md font-bold transition-all hover:opacity-90" style={{
              backgroundColor: '#E5E5E5',
              color: '#333333'
            }} data-id="element-1288">
                  ← Back
                </button>
                <button type="submit" disabled={submitStatus === 'submitting'} className="flex-1 py-4 rounded-md font-bold text-white transition-all hover:opacity-90" style={{
              backgroundColor: '#F4B400',
              opacity: submitStatus === 'submitting' ? 0.6 : 1
            }} data-id="element-1289">
                  {submitStatus === 'submitting' ? 'Submitting...' : 'Submit & Test'}
                </button>
              </div>
            </>}
        </form>
      </div>
    </div>;
};